import {
  GET_ANDROID_CLASSES_LIST_SUCCESS,
  GET_ANDROID_CLASS_APPS,
  GET_ANDROID_CLASS_APPS_SUCCESS,
} from '../constants/acategory';

const initState = {
  classes: {},
  classApps: {
    loading: true,
  },
};

const acategory = (state = initState, action = {}) => {
  switch (action.type) {
    case GET_ANDROID_CLASSES_LIST_SUCCESS:
      return { ...state, classes: action.data };
    case GET_ANDROID_CLASS_APPS:
      return { ...state, classApps: action.data };
    case GET_ANDROID_CLASS_APPS_SUCCESS:
      return { ...state, classApps: action.data };
    default:
      return state;
  }
};

export default acategory;
